export default __webpack_public_path__ + "media/zurb/img/legacy/reel/reel-large-f99e8090d58c9e2942484cdf94b2d2e1.png";